import React, { useEffect, useRef } from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Team from './components/Team';
import Values from './components/Values';
import Join from './components/Join';
import Footer from './components/Footer';
import Nav from './components/Nav';
import './App.css';

function App() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.12 }
    );
    document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="app">
      <div className="scanline" />
      <Nav />
      <Hero />
      <About />
      <Values />
      <Team />
      <Join />
      <Footer />
    </div>
  );
}

export default App;
